import {IS_DEBUG} from "./urlConfig";
import swal from "sweetalert";

let utilService = {};

let _console = function (string, value) {
  if (IS_DEBUG) {
    console.log("------------------------ Console --------------------------");
    console.log(string, value);
    console.log("-----------------------------------------------------------");
  }
};

let _showErrorsInDev = function (url, err, status, dataValue) {
  if (IS_DEBUG) {
    console.log("---------------------- Error ----------------------------");
    console.log("URL: ", url);
    console.log("Value JSON: ", dataValue);
    console.log("Erro: ", err);
    console.log("Status: ", status);
    console.log("---------------------------------------------------------");
  }
};

let _invalidToken = function (status) {
  if (status === 401) {
    localStorage.clear();
    this.$router.push({path: '/login'});
  }
};

let _randomToken = function () {
  let randomPool = new Uint8Array(32);
  crypto.getRandomValues(randomPool);
  let hex = '';
  for (let i = 0; i < randomPool.length; ++i) {
    hex += randomPool[i].toString(16);
  }
  return hex
};


let _checkPerfil = function (userId) {
  let listId = [];
  let onList = false;
  listId.push('2583EEFDA12A435B975E16A3A2462E6B');
  listId.push('9CCD76C3E8B14DE4AF3B40A6E95B002A');
  listId.push('FFBB255C43D94662A44DBAC8E3BDBB94');
  listId.push('990A001C581B4438A5C4A7C0F97E961B');
  listId.push('44C9738D1E544A65A87D4AF969528895');
  listId.push('9CCD76C3E8B14DE4AF3B40A6E95B002A');
  listId.push('C83385D8D4B147B088C2F232B19FA031');
  listId.push('4F176E9DF4F5452D84FC849CFC8A90AB');
  listId.push('B4CC6B129C9345B38CB45A981F2CDE26');
  listId.push('FFBB255C43D94662A44DBAC8E3BDBB94');
  listId.push('1DE4F38141DC481E99AE93762455A250');
  listId.push('888E3A62A1064311A08726A8E026EF0B');
  listId.push('802BB9C139E64E98AFD81286E355064D');
  listId.push('70F5A4CD8CD44B889FF82529F48BDAE5');
  listId.push('8F257EF8ADFC482B84FDE6F9CE002232');
  listId.push('8F257EF8ADFC482B84FDE6F9CE002232');
  listId.push('62C6AA2FD0564CA7AF4DEAB66C08CD40');
  listId.push('FE2CBCE3C4EC4997B8BBE471D9FA483A');
  listId.push('2B20CC86EC15474BBFA8B8C4301BC64E');
  listId.push('2EF79E31C9CF47329CFFA49CA374F6CE');
  listId.push('0152AA0DB48B4E72A91BFCC93C730FF0');

  for (let i = 0; i < listId.length; ++i) {
    if (userId === listId[i]) {
      onList = true;
    }

    if (listId.length === i + 1) {
      return onList
    }
  }

}

let _createSwal = function (title, text, type, btnText) {
  let objSwalText = {
    title: title ? title : "Aviso!",
    text: text,
    icon: type,
    buttons: {
      cancel: "Cancelar",
      catch: {
        text: btnText ? btnText : 'Confirmar',
        value: "confirm",
      }
    },
  };

  return swal(objSwalText);
}


utilService.console = _console;
utilService.checkP = _checkPerfil;
utilService.showErrorsInDev = _showErrorsInDev;
utilService.invalidToken = _invalidToken;
utilService.randomToken = _randomToken;
utilService.randomToken = _randomToken;

utilService.createSwal = _createSwal;

export const UTIL_SERVICE = utilService;
export const UTIL = utilService;



// WEBPACK FOOTER //
// ./src/utils.js